module.exports = __webpack_public_path__ + "static/media/Roboto-BlackItalic.2a09b4f5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-BlackItalic.ttf
// module id = 545
// module chunks = 0